export default "__VITE_ASSET__BoOFylMn__"